import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = {
    examinationId: String,
    url: String
  }

  async toggle(event) {
    const checkbox = this.checkboxTarget
    const isChecked = checkbox.checked

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.json()

      // サーバーからのレスポンスに基づいてチェックボックスの状態を更新
      if (data.success) {
        checkbox.checked = data.transferred_at !== null
      }
    } catch (error) {
      console.error('Error:', error)
      // エラー時は元の状態に戻す
      checkbox.checked = !isChecked
      alert('転記済み状態の更新に失敗しました')
    }
  }
}
